import { FCX, Tooltip } from "@datassential/platform-ui-lib";
import { ReactNode, useId, isValidElement, cloneElement, useMemo, ReactElement, ComponentProps } from "react";
import Popup from "@components/Popup";

const DATA_ATTR = "data-tooltip-id";

const TooltipWrapper: FCX<{
    thumbnail: ReactNode;
    tooltipProps?: Omit<ComponentProps<typeof Tooltip>, 'id'>;
}> = ({
    thumbnail,
    tooltipProps,
    children,
}) => {
    const tooltipId = useId();

    const tooltip = useMemo(
        () => (
            <Popup>
                <Tooltip
                    {...tooltipProps}
                    id={tooltipId}
                >
                    {children}
                </Tooltip>
            </Popup>
        ),
        [children, tooltipId, tooltipProps]
    );

    if (!children) {
        return <>{thumbnail}</>;
    }

    if (isValidElement(thumbnail)) {
        return (
            <>
                {cloneElement(thumbnail as ReactElement, { [DATA_ATTR]: tooltipId })}
                {tooltip}
            </>
        );
    }

    return (
        <>
            <span data-tooltip-id={tooltipId}>{thumbnail}</span>
            {tooltip}
        </>
    );
};

export default TooltipWrapper;